// import firebase from "firebase/app";
// import "firebase/firestore";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import apiClient from "../../../helpers/apiClient";
// const { Timestamp } = firebase.firestore;

const pageStyle = {
    display: "flex",
    flexDirection: "column",
    flex: "1 1 0%",
    minHeight: 0,
};

const contentStyle = {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflow: "hidden",
};

const tableContainerStyle = {
    flex: 1,
    overflow: "auto",
};

const paginateStyle = {
    display: "flex",
    flexDirection: "row",
    color: "#acacb9",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem 0",
};

const viewBtn = {
    textAlign: "center",
    fontSize: "1rem",
    color: "#5d5dff",
    borderRadius: "0.6rem",
    backgroundColor: "white",
    cursor: "pointer",
    padding: "0.3rem 0.8rem",
};

const CleanerStatusList = () => {
    const [cleanerStatus, setCleanerStatus] = useState([]);
    const [error, setError] = useState(null);
    const [pageNumber, setPageNumber] = useState(0);
    const [loading, setLoading] = useState(false);
    const [totalItems, setTotalItems] = useState(0);

    const statusPerPage = 10;

    useEffect(() => {
        const fetchCleanerStatus = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await apiClient.get("/api/cleaner-status/list", {
                    params: {
                        page: pageNumber,
                        limit: statusPerPage,
                    },
                });

                setCleanerStatus(response?.data?.data?.result);
                setTotalItems(response?.data?.meta?.total);
            } catch (err) {
                // console.error("Error fetching cleaner status: ", err);
                setError(`Failed to fetch cleaner status: ${err.message}`);
            } finally {
                setLoading(false);
            }
        };

        fetchCleanerStatus();
    }, [pageNumber]);

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (loading) {
        return (
            <div
                style={{
                    height: "full",
                    width: "full",
                    margin: "auto",
                    display: "flex",
                    justifyItems: "center",
                    alignItems: "center",
                }}>
                Loading...
            </div>
        );
    }

    const pageCount = Math.ceil(totalItems / statusPerPage);
    const changePage = ({ selected }) => {
        setPageNumber(selected);
    };

    // console.log(cleanerStatus);

    return (
        <div style={pageStyle}>
            <div style={contentStyle}>
                <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: "1rem",
                        }}>
                        <div className="text-[1.2rem] fontbold" style={{ flex: "1" }}>
                            Status <span className="text-[#5d5dff]">({totalItems})</span>
                        </div>
                        {/* <div>
              <input
                type="text"
                className="searchbar"
                placeholder="Search"
                ref={searchRef}
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm((prev) => e.target.value.toLowerCase());
                }}
              />
            </div>
            <Link to="/cleaner/create">
              <div
                className="updatebtn"
                style={{
                  width: "15rem",
                  background: "white",
                  color: "#5d5dff",
                }}
              >
                ➕ Create New Cleaner Status
              </div>
            </Link> */}
                    </div>

                    <div style={tableContainerStyle}>
                        <table className="sc-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Cleaner Id</th>
                                    <th>Cleaner Name</th>
                                    <th>Plate Number</th>
                                    <th>Date Time</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cleanerStatus?.map((status, index) => {
                                    const { id, cleanerData, carPlateNumber, date } = status;
                                    const formattedDate = date ? date.toDate() : new Date(date);
                                    const updatedDate = formattedDate.toLocaleDateString();
                                    const updatedTime = formattedDate.toLocaleTimeString();
                                    return (
                                        <tr key={index}>
                                            <td>{id}</td>
                                            <td>{cleanerData?.cleanerID}</td>
                                            <td>{cleanerData?.Name}</td>
                                            <td>{carPlateNumber}</td>
                                            <td>
                                                {updatedDate} <br /> {updatedTime}
                                            </td>
                                            <td>
                                                <Link to={`/cleaner-status/${id}`} style={viewBtn}>
                                                    View
                                                </Link>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    <div style={paginateStyle}>
                        <div className="info fontLight">
                            Page {pageNumber + 1} of {pageCount} pages | {pageNumber * statusPerPage + 1}-
                            {Math.min(totalItems, (pageNumber + 1) * statusPerPage)} items of total {totalItems} items
                        </div>
                        <ReactPaginate
                            previousLabel={""}
                            nextLabel={""}
                            pageCount={pageCount}
                            onPageChange={changePage}
                            containerClassName={"pagination fontRegular"}
                            activeClassName={"paginateactive"}
                            previousLinkClassName={"previousP"}
                            nextLinkClassName={"nextP"}
                            breakLabel={"..."}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CleanerStatusList;
